import axios, {AxiosResponse} from "axios";
import {APIS} from "../../../../static/apis";

export function removeEntitiesFromUser (email: string): Promise<AxiosResponse<{ data: boolean }>> {
  return axios.delete(
    APIS.BASE_AUTH_MS_URL + APIS.REMOVE_ENTITIES_FROM_USER,
    { params: { email } }
  );
}
